<ng-template #settingsTemplate>
    <app-tool-setting label="Hoogte">
        <app-range-slider
            [min]="1"
            [max]="maxRows"
            [(range)]="numRows"
            label="Rijen"
        ></app-range-slider>
        <app-range-slider
            [min]="1"
            [max]="maxCols"
            [(range)]="numCols"
            label="Kolommen"
        ></app-range-slider>
    </app-tool-setting>
    <app-tool-setting label="Vul in" class="tool-setting-groups">
        <div class="tool-setting-group">
            <app-radio-input
                [value]="'add'"
                [model]="addOrSubstract"
                (selected)="setAddOrSubstract('add')"
                >optellen</app-radio-input
            >
            <app-radio-input
                [value]="'substract'"
                [model]="addOrSubstract"
                (selected)="setAddOrSubstract('substract')"
                >aftrekken</app-radio-input
            >
        </div>
        <app-numbers-input
            (numberChoice)="handleNumberChoice($event)"
            (undo)="handleUndo()"
            (clear)="handleClear()"
        ></app-numbers-input>
    </app-tool-setting>
</ng-template>
<ng-template #contentTemplate>
    <svg
        id="Laag_1"
        data-name="Laag 1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        [attr.viewBox]="'0 0 ' + (numCols + 1) * 54 + ' ' + (numRows + 1) * 54"
        [ngStyle]="{
            'width.px': (numCols + 1) * 54,
            'height.px': (numRows + 1) * 54
        }"
    >
        <defs>
            <style>
                .cls-1,
                .cls-2,
                .cls-4,
                .cls-8 {
                    fill: none;
                }
                .cls-2 {
                    stroke: #008fd1;
                    stroke-linecap: round;
                    stroke-width: 4px;
                }
                .cls-3 {
                    fill: #fff;
                    stroke: #91989c;
                    stroke-width: 1.5px;
                }
                .cls-4,
                .cls-8 {
                    stroke: #a1a1a1;
                }
                .cls-4 {
                    stroke-width: 0.91px;
                }
                .cls-5 {
                    fill: #1d1d1b;
                }
                .cls-6 {
                    font-size: 26px;
                    font-family: UniversLTStd, Univers LT Std;
                }
            </style>
        </defs>

        <g class="blue-lines">
            <line
                class="cls-2"
                [attr.x1]="54 * (numCols + 1)"
                y1="53"
                x2="2"
                y2="53"
            />
            <line
                class="cls-2"
                x1="54"
                [attr.y1]="54 * (numRows + 1)"
                x2="54"
                y2="2"
            />
        </g>

        <g class="header-table">
            @for (columns of [].constructor(numCols); track $index; let index =
            $index) {
            <g class="column-header">
                <g
                    class="cell"
                    [ngStyle]="{transform: 'translateX(' + index * 54 + 'px)'}"
                >
                    <rect
                        style="pointer-events: all"
                        (click)="setActiveField(index)"
                        class="cls-3"
                        x="60.12"
                        y="0.75"
                        width="46.5"
                        height="46.5"
                    />
                    <text
                        class="cls-6"
                        text-anchor="middle"
                        transform="translate(83.25 33.19)"
                    >
                        {{ values[index] }}
                    </text>
                    @if (activeField === (index)) {
                    <g>
                        <line
                            class="cls-4"
                            x1="67.33"
                            y1="40.5"
                            x2="99.33"
                            y2="40.5"
                        />
                    </g>
                    }
                </g>
            </g>
            } @for (rows of [].constructor(numRows); track $index; let index =
            $index) {
            <g class="row-header">
                <g
                    class="cell"
                    [ngStyle]="{transform: 'translateY(' + index * 54 + 'px)'}"
                >
                    <rect
                        style="pointer-events: all"
                        (click)="setActiveField(index + maxCols)"
                        class="cls-3"
                        x="2.12"
                        y="58.75"
                        width="46.5"
                        height="46.5"
                    />
                    <text
                        class="cls-6"
                        text-anchor="middle"
                        transform="translate(25.25 91.19)"
                    >
                        {{ values[index + maxCols] }}
                    </text>
                    @if (activeField === (index + maxCols)) {
                    <g>
                        <line
                            class="cls-4"
                            x1="10.33"
                            y1="97.39"
                            x2="39.87"
                            y2="97.39"
                        />
                    </g>
                    }
                </g>
            </g>
            }
            <g class="symbol">
                <rect
                    class="cls-3"
                    x="2.12"
                    y="0.75"
                    width="46.5"
                    height="46.5"
                />
                @if (addOrSubstract === 'add') {
                <text
                    class="cls-6"
                    style="font-weight: bold"
                    text-anchor="middle"
                    transform="translate(25.25 32.5)"
                >
                    +
                </text>
                } @if (addOrSubstract === 'substract') {
                <text
                    class="cls-6"
                    style="font-weight: bold"
                    text-anchor="middle"
                    transform="translate(25.25 32.5)"
                >
                    –
                </text>
                }
            </g>
        </g>

        @for (rows of [].constructor(numRows); track $index; let parentindex =
        $index) {
        <g class="rows">
            @for (columns of [].constructor(numCols); track $index; let index =
            $index) {
            <g class="columns">
                <g
                    class="cell"
                    [ngStyle]="{
                        transform:
                            'translate(' +
                            index * 54 +
                            'px, ' +
                            parentindex * 54 +
                            'px)'
                    }"
                >
                    <rect
                        style="pointer-events: all"
                        (click)="
                            setActiveField((index + 1) * (parentindex + 100))
                        "
                        class="cls-3"
                        x="60.12"
                        y="58.75"
                        width="46.5"
                        height="46.5"
                    />
                    <text
                        class="cls-6"
                        text-anchor="middle"
                        transform="translate(83.25 91.19)"
                    >
                        {{ values[(index + 1) * (parentindex + 100)] }}
                    </text>
                    @if (activeField === (index + 1) * (parentindex + 100)) {
                    <g>
                        <line
                            class="cls-4"
                            x1="67.33"
                            y1="98.33"
                            x2="99.33"
                            y2="98.33"
                        />
                    </g>
                    }
                </g>
            </g>
            }
        </g>
        }
    </svg>
</ng-template>
